import React, { FC } from 'react';
import { Timeline } from 'rsuite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDot } from '@fortawesome/free-solid-svg-icons';
import clsx from 'clsx';
import { getFormattedDate } from '../../utils/utilities';
import './ActivityTimeline.scss';
import { dotColor } from '../../utils/timeline-utils';
import { useWindowSize } from '../../constants/useWindowSize';
import { ButtonComponent } from '../ButtonComponent';
import { IOrderActivityLogData } from '../../store/order/order-interfaces';
import { fetchOrderDetailsData } from '../../store/order/actions/order';
import { useOrdersContext } from '../../store/order/order-context';
import { useParams } from 'react-router-dom';
import { EmptyState } from '../EmptyState';
interface Props {
	activityList: IOrderActivityLogData[];
	openModal?: (value: string) => void;
	openArchiveModal?: () => void;
	setScript?: (value: string) => void;
	checkedItemId?: number;
	setCheckedItemId?: (value: number) => void;
}

export const ActivityTimeline: FC<Props> = (props) => {
	const { activityList, openModal, setScript, checkedItemId, setCheckedItemId, openArchiveModal } = props;

	const { id } = useParams<{ id: string }>();
	const { orderContextState: { enableArchiveSearch }, dispatch } = useOrdersContext();

	const [width] = useWindowSize();

	const onActionLogItemClick = (id: number): void => {
		setCheckedItemId(id);
		const selectedActivityLog = activityList?.find(el => el?.id === id);

		if (setScript) {
			setScript(selectedActivityLog?.data);
		}

		if (width < 768 && openModal) {
			openModal(selectedActivityLog?.data);
		}
	};

	if (!activityList?.length && enableArchiveSearch) {
		return (
			<ButtonComponent
				buttonName="Try load from archive"
				additionalClass="btn-sm load-archive-btn"
				onButtonClick={async (): Promise<void> => {
					openArchiveModal();
					await fetchOrderDetailsData(dispatch, id);
				}}
			/>
		);
	} else if (!activityList?.length) {
		return <EmptyState title="No activity logs found"/>;
	}

	return (
		<>
			<Timeline endless>
				{
					activityList?.map(({ createdOn, informationLevel, id, name, meta, note, user }) => {
						const createdOnDate = getFormattedDate(createdOn, 'yyyy-MM-dd HH:mm:ss');
						return (
							<Timeline.Item
								key={createdOn}
								dot={
									<FontAwesomeIcon
										icon={faCircleDot}
										className={clsx('position-absolute timeline-dot', dotColor(informationLevel), checkedItemId === id && ' timeline-dot-active-bgc')}
									/>
								}
								time={createdOnDate}
								onClick={(): void => setScript && onActionLogItemClick(id)}
								className={clsx(setScript && 'cursor-pointer', checkedItemId === id && 'active-bgc')}
							>
								<div className="fw-bolder">
									{name}
								</div>
								{
									(!!user || !!meta) && (
										<div className="text-muted">
											{!!user && <span className="fw-bolder me-1">{user}</span>}
											{!!meta && <span>{meta}</span>}
										</div>
									)
								}
								{
									note && (
										<div className="text-muted">
											<div className="fw-bolder mt-2">Note:</div>
											<div className="">{note}</div>
										</div>
									)
								}

							</Timeline.Item>
						);
					})
				}
			</Timeline>
		</>
	);
};
